// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/drawer/style/index.less
// module id = 1185
// module chunks = 0